var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DetailsFilters',{attrs:{"filters":_vm.filters,"is-loading":_vm.isLoading},on:{"update:filters":function($event){_vm.filters=$event},"clear":_vm.clearFilters,"update":_vm.update}}),_c('DetailsTable',{attrs:{"data":_vm.statistic,"is-loading":_vm.isLoading,"currency":_vm.currency_}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }